/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Dialog_Rename_Audio_TitleInputs */

const en_dialog_rename_audio_title = /** @type {(inputs: Dialog_Rename_Audio_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rename audio ${i?.title}`)
};

const es_dialog_rename_audio_title = /** @type {(inputs: Dialog_Rename_Audio_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renombrar audio ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Rename audio {title}" |
*
* @param {Dialog_Rename_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_rename_audio_title = /** @type {((inputs: Dialog_Rename_Audio_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Rename_Audio_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_rename_audio_title(inputs)
	return en_dialog_rename_audio_title(inputs)
});